"use strict";

var _interopRequireDefault = require("E:/start-cms/back-front/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("E:/start-cms/back-front/node_modules/@babel/runtime/helpers/objectSpread2"));

var _RightPanel = _interopRequireDefault(require("@/components/RightPanel"));

var _Breadcrumb = _interopRequireDefault(require("@/components/Breadcrumb"));

var _components = require("./components");

var _ResizeHandler = _interopRequireDefault(require("./mixin/ResizeHandler"));

var _vuex = require("vuex");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'Layout',
  components: {
    AppMain: _components.AppMain,
    Navbar: _components.Navbar,
    RightPanel: _RightPanel.default,
    Settings: _components.Settings,
    Sidebar: _components.Sidebar,
    TagsView: _components.TagsView,
    Breadcrumb: _Breadcrumb.default
  },
  mixins: [_ResizeHandler.default],
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapState)({
    layout: function layout(state) {
      return state.core.config.layout;
    },
    sidebar: function sidebar(state) {
      return state.app.sidebar;
    },
    device: function device(state) {
      return state.app.device;
    },
    showSettings: function showSettings(state) {
      return state.setting.showSettings;
    },
    needTagsView: function needTagsView(state) {
      return state.setting.tagsView;
    },
    fixedHeader: function fixedHeader(state) {
      return state.setting.fixedHeader;
    }
  })), {}, {
    classObj: function classObj() {
      return {
        top: this.layout === 'top',
        left: this.layout === 'left',
        fixedHeader: this.fixedHeader,
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        hasTagsView: this.needTagsView,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      };
    }
  }),
  methods: {
    handleClickOutside: function handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', {
        withoutAnimation: false
      });
    }
  }
};
exports.default = _default;